import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <MediaSection />
        <UpdatesSection />
        <CardsSection />
        <CarouselSection />
        <TopicsSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}